// extracted by mini-css-extract-plugin
export default {"aside__wrapper":"style_aside__wrapper__qK1hc","user_info":"style_user_info__EXnck"};